export interface SecurityActivityLogsInput {
  foundationId: string;
  projectId: string;
  yearType: string;
}
